import { monday } from '../platformSpecific/monday';
import * as Sentry from '@sentry/react';

export const notice = (message, type = 'info', timeout = 10000) => {
  monday.execute('notice', { message, type, timeout });
};

export const errorNoticeDefault = (error) => {
  Sentry.captureException(error);
  notice('Oops! Something went wrong, try again later.', 'error');
};

export default notice;
